import * as React from 'react';
import { useMediaQuery, breakPoints, Scrollbar } from '@gcl/react-core';
import './PageLayout.scss';
import classNames from 'classnames';

export interface IRenderMainContentProps {
  isMenuHidden: boolean;
}

export interface IPageLayoutProps {
  renderMainContent: (props: IRenderMainContentProps) => React.ReactNode;
  rightMenu?: React.ReactNode;
  isUseRightMenu?: boolean;
  isGlobalPage?: boolean;
}

export const PageLayout: React.FC<IPageLayoutProps> = ({
  renderMainContent,
  rightMenu,
  isUseRightMenu = false,
  isGlobalPage = false,
}) => {
  const isMd = useMediaQuery(breakPoints.breakpointMd);
  const isSm = useMediaQuery(breakPoints.breakpointSm);
  const isXs = useMediaQuery(breakPoints.breakpointXs);
  const isMenuHidden = isMd || isSm || isXs;

  return (
    <div className={`gcl-gems-page-layout-container ${isXs ? 'gcl-gems-page-layout-container-mobile' : ''}`}>
      <div className={classNames(`gcl-gems-page-layout-main-content`, { 'full-width': isMenuHidden })}>
        <Scrollbar>
          {isGlobalPage ? (
            <div className="gcl-gems-global-page-layout-main-container">{renderMainContent({ isMenuHidden })}</div>
          ) : (
            renderMainContent({
              isMenuHidden,
            })
          )}
        </Scrollbar>
      </div>
      <div className={`gcl-gems-page-layout-right-menu ${!isUseRightMenu || isMenuHidden ? 'hide' : ''}`}>
        {rightMenu}
      </div>
    </div>
  );
};
